if (typeof HeroCarousel === 'undefined') {
    class HeroCarousel extends HTMLElement {
        connectedCallback() {

            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            whenReady('Swiper', () => {
                try {

                    const slideCount = swiperContainer.querySelectorAll('.swiper-wrapper > .swiper-slide').length;

                    this.swiper = new Swiper(swiperContainer, {
                        loop: slideCount > 1,
                        a11y: true,
                        pauseOnMouseEnter: false,
                        watchSlidesProgress: true,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        mousewheel: {
                            enabled: !window.isSafari(),
                            forceToAxis: window.isSafari() ? false : true,
                            thresholdDelta: 10
                        },
                        navigation: {
                            nextEl: this.querySelector('.swiper-next-button'),
                            prevEl: this.querySelector('.swiper-prev-button'),
                        },
                        modules: [Swiper.Mousewheel, Swiper.EffectFade, Swiper.Autoplay, Swiper.A11y, Swiper.Navigation]
                    });

                    const activateSlideVideos = (activeSlide) => {
                        if (!activeSlide) {
                            swiperContainer.classList.remove('swiper--video-active');
                            return;
                        }

                        // Pause videos on inactive slides so only the current slide decodes.
                        this.swiper.slides.forEach((slide) => {
                            if (slide === activeSlide) return;
                            slide.querySelectorAll('video').forEach((video) => {
                                try { video.pause(); } catch (_) {}
                            });
                        });

                        const videos = activeSlide.querySelectorAll('video');
                        if (!videos.length) {
                            swiperContainer.classList.remove('swiper--video-active');
                            return;
                        }

                        swiperContainer.classList.add('swiper--video-active');

                        videos.forEach((video) => {
                            // Lazy slides keep sources on data-src until this slide is active.
                            const hydrated = typeof window.hydrateLazyVideoSources === 'function'
                                && window.hydrateLazyVideoSources(video);

                            // HTML autoplay already started this video. Touching muted / play()
                            // again makes mobile browsers drop back to the poster, then start over.
                            if (!hydrated && video.autoplay && !video.paused) return;

                            // Preserve muted state if user has previously unmuted this video
                            const wasUnmuted = video.dataset.userUnmuted === 'true';
                            if (!wasUnmuted && !video.muted) {
                                video.muted = true;
                            }

                            video.playsInline = true;

                            const playPromise = video.play();
                            if (playPromise !== undefined) {
                                playPromise.catch((error) => {
                                    console.log('Video autoplay prevented:', error);
                                });
                            }
                        });
                    };

                    this.swiper.on('slideChange', () => {
                        activateSlideVideos(this.swiper.slides[this.swiper.activeIndex]);
                    });

                    // Initial active slide (IO must not hydrate stacked inactive slides).
                    activateSlideVideos(this.swiper.slides[this.swiper.activeIndex]);

                    if (this.querySelectorAll(".swiper-next-button").length) {
                        this.querySelectorAll(".swiper-next-button").forEach($button => {
                            $button.addEventListener("click", e => {
                                e.preventDefault();
                                this.swiper.slideNext();
                            });
                        });
                    }
                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

    }

    if (!window.customElements.get('hero-carousel')) {
        window.customElements.define('hero-carousel', HeroCarousel);
    }
}
